import CustomerInfoForm from '../../../components/forms/CustomerInfoForm/CustomerInfoForm';
import CheckoutBox from '../../../components/core/CheckoutBox/CheckoutBox';
import BillingAddressForm from './BillingAddressForm/BillingAddressForm';
import CreditCheck from './CreditCheck/CreditCheck';
import AlternateContactForm from '../../../components/forms/AlternateContactForm/AlternateContactForm';

export interface ICustomerInfoProps {
    creditCheckFailureFollowUpTitle?: string;
    creditCheckFailureFollowUpMessage?: string;
}

const CustomerInfo = (props: ICustomerInfoProps) => {
    const {
        creditCheckFailureFollowUpTitle: creditCheckFailureFollowUpTitle,
        creditCheckFailureFollowUpMessage: creditCheckFailureFollowUpMessage
    } = props;

    return (
        <>
            <CheckoutBox header={'Customer Info'}>
                <CustomerInfoForm />
            </CheckoutBox>

            <CheckoutBox header={'Billing'}>
                <BillingAddressForm />
            </CheckoutBox>

            <CheckoutBox header={'Alternate Contact'}>
                <AlternateContactForm />
            </CheckoutBox>

            <CreditCheck
                failureFollowUpTitle={creditCheckFailureFollowUpTitle}
                failureFollowUpMessage={creditCheckFailureFollowUpMessage}
            />
        </>
    );
};

export default CustomerInfo;
